@if (isShowProgress | async) {
<div class="progress-container items-center">
  <div class="flex-center flex-direction-column">
    <p class="white">Uploading... {{ uploadProgress | async }} {{ (uploadProgress | async) ? '%' : '' }}</p>
    <mat-progress-spinner diameter="60" [value]="uploadProgress | async" mode="determinate">
    </mat-progress-spinner>
  </div>
</div>
}